import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { TGridSchema, useAuth, useFetch, useForm, useGrid, useModal, usePage, useStore, useToast } from "@/comn/hooks";
import {
    APIS,
    SF_IQS_SRCH,
    SG_IQS,
    URLS,
    getIqsAccessData,
} from "@/tz/go/egaz/osci/ptl/mypg/iqs/services/OsciMypgIqsService";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*
 * Role Management List
 * !== 역할 관리 목록 ==!
 */
export const OSCI0102002Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage();
    const modal = useModal();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const toast = useToast();
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });

    const form = {
        iqsSrch: useForm({
            defaultSchema: SF_IQS_SRCH,
            defaultValues: {
                ...pgeStore?.form,
                regstSrchStrtDt: comnUtils.getDate({ m: -1 }),
                regstSrchEndDt: comnUtils.getDate(),
            },
        }),
    };

    const grid = {
        iqs: useGrid({
            defaultSchema: SG_IQS,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // get List Of Bulletin board Message !== 게시글 목록 조회==!
        getIQSList: useFetch({
            api: (page = grid.iqs.page) =>
                APIS.getIQSList({ ...form.iqsSrch.getValues(), ...getIqsAccessData(auth) }, page, grid.iqs.size),
            enabled: comnUtils.isEmpty(form.iqsSrch.errors),
            key: [grid.iqs.page, grid.iqs.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.iqsSrch.getValues(),
                    page: grid.iqs.page,
                    size: grid.iqs.size,
                });
            },
            onError: () => {
                toast.showToast({ type: "error", content: "msg.osc.00043" }); // Failed to select. !== 조회가 실패하였습니다. ==!
            },
        }),
    };
    const handler = {
        onSrchBtnClick: () => {
            grid.iqs.setPage(0);
            fetch.getIQSList.fetch(0);
        },
    };
    const render = {
        cell: {
            appNo: (props: any) => {
                const { rowValues, value } = props;
                console.log(rowValues);
                return <Link to={`${URLS.osci0102003s}/${rowValues.iqsId}?menuId=${menuId}`}>{value}</Link>;
            },
        },
    };

    useEffect(() => {
        fetch.getIQSList.fetch();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.iqsSrch.schema.frstRgsrDtmRnge} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            {/* <Group.Control {...form.iqsSrch.schema.reffNo} /> */}
                            <Group.Control {...form.iqsSrch.schema.srchAppNo} />
                            <Group.Control {...form.iqsSrch.schema.srchFrstRegstId} />
                        </Group.Row>
                        {/* <Group.Row>
                        </Group.Row> */}
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button
                                role={"reset"}
                                onClick={() => {
                                    form.iqsSrch.reset();
                                    form.iqsSrch.setValues({
                                        reffNo: "",
                                        srchAppNo: "",
                                        srchFrstRegstId: "",
                                        regstSrchStrtDt: comnUtils.getDate({ m: -1 }),
                                        regstSrchEndDt: comnUtils.getDate(),
                                    });
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onSrchBtnClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.iqs.grid} data={fetch.getIQSList.data?.myIqsList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
